import { render, staticRenderFns } from "./MagazzinoArticoliGiacenzeListComponent.vue?vue&type=template&id=539a0bbe&scoped=true"
import script from "./MagazzinoArticoliGiacenzeListComponent.vue?vue&type=script&lang=js"
export * from "./MagazzinoArticoliGiacenzeListComponent.vue?vue&type=script&lang=js"
import style0 from "./MagazzinoArticoliGiacenzeListComponent.vue?vue&type=style&index=0&id=539a0bbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539a0bbe",
  null
  
)

export default component.exports